// O relatório de relatos — tipos e o que a tela e o PDF compartilham.
import { formatarData } from '@medicov1/shared';

export type PeriodoDosRelatos = 'diario' | 'semanal' | 'quinzenal' | 'geral';

export const PERIODOS_DOS_RELATOS: { chave: PeriodoDosRelatos; rotulo: string }[] = [
  { chave: 'diario', rotulo: 'Diário' },
  { chave: 'semanal', rotulo: 'Semanal' },
  { chave: 'quinzenal', rotulo: 'Quinzenal' },
  { chave: 'geral', rotulo: 'Geral' },
];

export interface RelatoDTO { texto: string; ocorreuEm: string; autor: string }

export interface RelatosDTO {
  paciente: { apelido: string; idade: number; quarto: string | null; internadoDesde: string };
  gerado: { em: string; periodo: PeriodoDosRelatos; periodoRotulo: string; desde: string };
  total: number;
  autores: string[];
  /** Do dia mais novo para o mais velho; dentro do dia, da hora mais nova para a mais velha. */
  dias: { dia: string; relatos: RelatoDTO[] }[];
}

const SEMANA = ['domingo', 'segunda', 'terça', 'quarta', 'quinta', 'sexta', 'sábado'];

/**
 * "quinta, 25/09/2026". O dia da semana entra porque é assim que a família
 * lembra ("foi na terça que ela tremeu"), não pela data.
 *
 * Conta em UTC sobre o dia PURO: o dia já veio convertido para Brasília pela
 * API, e reconverter aqui o empurraria para trás.
 */
export function rotuloDoDia(dia: string): string {
  const [ano, mes, d] = dia.split('-').map(Number);
  return `${SEMANA[new Date(Date.UTC(ano!, mes! - 1, d!)).getUTCDay()]}, ${formatarData(dia)}`;
}

export const LEGENDA_DOS_RELATOS =
  'O que a família viu e anotou no quarto, do jeito que foi escrito. Não foi revisado pela equipe '
  + 'e não é interpretação: muita coisa aqui não tem importância clínica, e está junto justamente '
  + 'para poder ser cruzada com os exames e o que a equipe disse.';
